import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const ACCOUNT_TYPES = [
  'PersonalAccount',
  'CompanyAccount',
  'ProductAccount',
  'AgentAccount',
]

const entityColumns = {
  id: {
    model_name: 'Account',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Account',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Account',
    column_type: 'datetime',
  },
  address: {
    model_name: 'Account',
    column_type: 'string',
  },
  city: {
    model_name: 'Account',
    column_type: 'string',
  },
  email: {
    model_name: 'Account',
    column_type: 'string',
  },
  name: {
    model_name: 'Account',
    column_type: 'string',
  },
  number: {
    model_name: 'Account',
    column_type: 'string',
  },
  phone: {
    model_name: 'Account',
    column_type: 'string',
  },
  referrer: {
    model_name: 'Account',
    column_type: 'string',
  },
  remark: {
    model_name: 'Account',
    column_type: 'string',
  },
  type: {
    model_name: 'Account',
    column_type: 'type',
    extra: {
      options: ['PersonalAccount', 'CompanyAccount', 'ProductAccount', 'AgentAccount'],
    },
  },
  kind: {
    model_name: 'Account',
    column_type: 'enum',
  },
  risk_assessment_level: {
    model_name: 'Account',
    column_type: 'enum',
  },
  status: {
    model_name: 'Account',
    column_type: 'enum',
  },
  user: {
    model_name: 'Account',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'Account',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  is_staff: {
    model_name: 'Account',
    column_type: 'boolean',
  },
  certificate_end_date: {
    model_name: 'Account',
    column_type: 'date',
  },
  agent_target: {
    model_name: 'Account',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'agent_target',
      model_name: 'Account',
      foreign_key: 'agent_target_id',
    },
  },
  agent_target_id: {
    model_name: 'Account',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'agent_target',
      model_name: 'Account',
      foreign_key: 'agent_target_id',
    },
  },
  trade_account: {
    model_name: 'Account',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'trade_account',
      model_name: 'Account',
      foreign_key: 'trade_account_id',
    },
  },
  trade_account_id: {
    model_name: 'Account',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'trade_account',
      model_name: 'Account',
      foreign_key: 'trade_account_id',
    },
  },
  reject_reason: {
    model_name: 'Account',
    column_type: 'string',
  },
  account_status: {
    model_name: 'Account',
    column_type: 'enum',
  },
  login_activities_count: {
    model_name: 'Account',
    column_type: 'string',
  },
  trade_account_account_funds: {
    model_name: 'Account',
    column_type: 'string',
  },
  personas: {
    model_name: 'Account',
    column_type: 'text',
  },
  audio_or_video_recording_file: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  bank_card_scan_file: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  fund_contract: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  number_scan_file: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  proof_of_assets: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  qualified_investor_commitment_letter: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  risk_assessment_file: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  risk_disclosure: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  supplementary_agreement_to_fund_contract: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  other_files: {
    model_name: 'Account',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  has_video_records: {
    model_name: 'Account',
    column_type: 'string',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
